import { useIsAuthenticated } from 'react-auth-kit';
import { NotificationHook } from '@hooks/NotificationHook';

export function Notifications() {
  const isAuthnenticated = useIsAuthenticated();

  // This a workaround to be able to use the hook conditionally
  return (isAuthnenticated() ? <NotificationHook /> : null);
}
